if(document.querySelector(".collection-main__grid") !== null){

    //MAIN NAV BUTTON CLICKS
    // $mainNav.querySelectorAll(".button").forEach($button => {
    //     $button.addEventListener("click", e => {
    //         e.preventDefault();
    //         for (const [key, value] of searchParams.entries()) {
    //             searchParams.delete(key);
    //         }
    //         $mainNav.querySelectorAll(".button").forEach($b => {
    //             $b.classList.remove("active")
    //         })
    //         $button.classList.add("active")
    //         $radios.forEach(($r) => {
    //             $r.checked = false;
    //         })
    //         filterProducts($button.href, true)
    //     })
    // })

    //FILTERING
    let currentUrl = window.location.href;
    let url = new URL(currentUrl);
    let searchParams = url.searchParams;    
    const $main = document.querySelector(".collection-main");
    const $pagination = document.querySelector(".pagination");
    const $productGrid = document.querySelector(".collection-main__grid-products");
    const $sortByMobile = document.getElementById("sort-by-mobile");
    const $radios = document.querySelectorAll(".collection-main__grid--filters .form__radio");
    const $customFilterRadios = document.querySelectorAll(".custom-filter-category-radio");

    // Function to load all products without pagination for filtering
    const loadAllProductsForFilter = async () => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('view', 'all');
        currentUrl.searchParams.delete('page');
        
        console.log('=== LOADING ALL PRODUCTS ===');
        console.log('URL with view=all:', currentUrl.toString());
        
        $main.classList.add("collection-main--loading");
        
        try {
            // First, load page 1 with view=all (up to 250 products)
            let allProductsHTML = '';
            let page = 1;
            let hasMorePages = true;
            
            while(hasMorePages) {
                // Create URL for this page (remove view=all as Shopify doesn't recognize it)
                const pageUrl = new URL(window.location.origin + window.location.pathname);
                // Copy all search params except view=all
                const currentParams = new URL(window.location.href).searchParams;
                currentParams.forEach((value, key) => {
                    if(key !== 'view') {
                        pageUrl.searchParams.set(key, value);
                    }
                });
                pageUrl.searchParams.set('page', page.toString());
                
                console.log(`Loading page ${page}...`);
                console.log(`Page URL: ${pageUrl.toString()}`);
                
                const response = await fetch(pageUrl.toString());
                const html = await response.text();
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let prodsHTML = doc.querySelector(".collection-main__grid-products");
                
                if(!prodsHTML) {
                    console.log(`No products found on page ${page}`);
                    hasMorePages = false;
                    break;
                }
                
                // Extract product divs from this page
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = prodsHTML.innerHTML;
                const productsOnPage = tempDiv.querySelectorAll('div[data-filter-category]');
                
                console.log(`Page ${page}: ${productsOnPage.length} products loaded`);
                
                if(productsOnPage.length === 0) {
                    hasMorePages = false;
                    break;
                }
                
                // Append products from this page
                productsOnPage.forEach(product => {
                    allProductsHTML += product.outerHTML;
                });
                
                // Check if there's a next page by looking at pagination
                const pagination = doc.querySelector(".pagination");
                let hasNextPage = false;
                
                if(pagination) {
                    // Check for .next class with a link
                    const nextLink = pagination.querySelector('.next a');
                    if(nextLink && nextLink.getAttribute('href')) {
                        hasNextPage = true;
                        console.log('Next page link found via .next class');
                    } else {
                        // Check for any link that points to the next page number
                        const allPaginationLinks = pagination.querySelectorAll('a');
                        allPaginationLinks.forEach(link => {
                            const href = link.getAttribute('href') || '';
                            // Check if link contains page parameter with value greater than current page
                            const pageMatch = href.match(/[?&]page=(\d+)/);
                            if(pageMatch) {
                                const linkPage = parseInt(pageMatch[1]);
                                if(linkPage === page + 1) {
                                    hasNextPage = true;
                                    console.log(`Next page link found: page ${linkPage}`);
                                }
                            }
                        });
                    }
                    
                    // Also check pagination HTML content for page numbers
                    const paginationText = pagination.textContent || '';
                    const pageNumbers = paginationText.match(/\d+/g);
                    if(pageNumbers) {
                        const maxPage = Math.max(...pageNumbers.map(n => parseInt(n)));
                        if(maxPage > page) {
                            hasNextPage = true;
                            console.log(`Pagination shows page ${maxPage} exists (current: ${page})`);
                        }
                    }
                    
                    console.log(`Pagination found: ${!!pagination}, Has next page: ${hasNextPage}`);
                } else {
                    console.log('No pagination element found - assuming single page');
                }
                
                // Determine if there are more pages
                // Priority: Check pagination first, then product count
                if(hasNextPage) {
                    page++;
                    console.log(`More pages available, loading page ${page}...`);
                } else if(productsOnPage.length < 12) {
                    // Less than 12 products and no next page = definitely last page
                    hasMorePages = false;
                    console.log(`Page ${page} has less than 12 products and no next page - this is the last page`);
                } else {
                    // Exactly 12 products but no next page link = might be last page
                    // But let's be safe and check if we got exactly the pagination limit
                    hasMorePages = false;
                    console.log(`No next page link found - assuming this is the last page (${productsOnPage.length} products on this page)`);
                }
            }
            
            console.log(`Total pages loaded: ${page}`);
            console.log(`Total products HTML length: ${allProductsHTML.length}`);
            
            // Set all products HTML
            $productGrid.innerHTML = allProductsHTML;
            $main.classList.remove("collection-main--loading");
            history.pushState({}, null, currentUrl.toString());
            
            // Re-add event listeners for newly loaded checkboxes
            addCustomFilterListeners();
            // Apply filter to show only matching products
            filterProductsByCategory(true);
            
            // Hide pagination completely and clear its content
            if($pagination) {
                $pagination.style.display = 'none';
                $pagination.innerHTML = '';
                console.log('Pagination hidden and cleared after loading all products');
            }
        } catch(error) {
            console.error('Error loading all products:', error);
            $main.classList.remove("collection-main--loading");
        }
    };

    // Function to add event listeners to custom filter checkboxes
    const addCustomFilterListeners = () => {
        const $customFilterRadios = document.querySelectorAll(".custom-filter-category-radio");
        $customFilterRadios.forEach(($radio) => {
            // Remove existing listener if any (to avoid duplicates)
            const newRadio = $radio.cloneNode(true);
            $radio.parentNode.replaceChild(newRadio, $radio);
            
            newRadio.addEventListener('change', () => {
                // Check if any filters are still checked
                const $allCheckboxes = document.querySelectorAll(".custom-filter-category-radio");
                const hasAnyChecked = Array.from($allCheckboxes).some($cb => $cb.checked);
                
                if(!hasAnyChecked) {
                    // If no filters are checked, show all products immediately and reload page
                    const $products = document.querySelectorAll(".collection-main__grid-products > div[data-filter-category]");
                    $products.forEach($product => {
                        $product.style.display = '';
                    });
                    // Show pagination
                    if($pagination) {
                        $pagination.style.display = '';
                    }
                    // Reload page to reset everything properly (remove view=all)
                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.delete('filter.p.custom.filter_category');
                    currentUrl.searchParams.delete('view');
                    currentUrl.searchParams.set('page', '1');
                    window.location.href = currentUrl.toString();
                } else {
                    // If filters are checked, load ALL products without pagination
                    loadAllProductsForFilter();
                }
            });
        });
    };

    // CUSTOM FILTER BY BENEFIT (client-side filtering with all products loaded)
    const filterProductsByCategory = (skipReload = false) => {
        const $products = document.querySelectorAll(".collection-main__grid-products > div[data-filter-category]");
        const selectedCategories = [];
        
        // Get checkboxes dynamically in case they were reloaded via AJAX
        const $customFilterCheckboxes = document.querySelectorAll(".custom-filter-category-radio");
        $customFilterCheckboxes.forEach($radio => {
            if($radio.checked) {
                const categoryHandle = $radio.getAttribute('data-filter-value');
                selectedCategories.push(categoryHandle);
            }
        });

        // DEBUG: Console logs
        console.log('=== FILTER DEBUG ===');
        console.log('Total products found:', $products.length);
        console.log('Selected categories:', selectedCategories);
        
        // Log all products with their filter categories
        const productsInfo = [];
        $products.forEach($product => {
            const productHandle = $product.getAttribute('data-product-handle');
            const productCategories = $product.getAttribute('data-filter-category') || '';
            productsInfo.push({
                handle: productHandle,
                categories: productCategories,
                categoriesArray: productCategories ? productCategories.split(' ').filter(cat => cat.trim() !== '') : []
            });
        });
        console.log('All products with their filter categories:', productsInfo);

        // If no filters are selected, show all products immediately
        if(selectedCategories.length === 0) {
            console.log('No filters selected - showing all products');
            // Show all products immediately
            $products.forEach($product => {
                $product.style.display = '';
            });
            
            // Check if view=all is in URL - if so, hide pagination
            const currentUrl = new URL(window.location.href);
            const hasViewAll = currentUrl.searchParams.has('view') && currentUrl.searchParams.get('view') === 'all';
            
            if(hasViewAll) {
                console.log('view=all in URL - hiding pagination');
                if($pagination) {
                    $pagination.style.display = 'none';
                }
            } else {
                // Show pagination when no custom filters are active and no view=all
                if($pagination) {
                    $pagination.style.display = '';
                }
            }
            
            // If we need to reload (not after AJAX), do a full page reload to reset everything
            if(!skipReload) {
                // Remove any custom filter params and view=all from URL
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.delete('filter.p.custom.filter_category');
                currentUrl.searchParams.delete('view');
                currentUrl.searchParams.set('page', '1');
                // Only reload if URL actually changed
                if(currentUrl.toString() !== window.location.href) {
                    // Do a full page reload to ensure everything resets properly
                    window.location.href = currentUrl.toString();
                    return;
                }
            }
            return;
        }

        // If filters are selected, apply filtering
        console.log('Filters selected - applying filter logic');
        let visibleCount = 0;
        const filteredProducts = [];

        $products.forEach($product => {
            const productHandle = $product.getAttribute('data-product-handle');
            const productCategories = $product.getAttribute('data-filter-category');
            if(!productCategories) {
                console.log(`Product ${productHandle}: No categories - hiding`);
                $product.style.display = 'none';
                return;
            }
            
            // Split product categories (can be multiple separated by space)
            const productCategoryArray = productCategories.split(' ').filter(cat => cat.trim() !== '');
            
                // Check if product has any of the selected categories
                const hasMatchingCategory = selectedCategories.some(selectedCat => 
                    productCategoryArray.some(productCat => productCat === selectedCat)
                );
            
            if(hasMatchingCategory) {
                $product.style.display = '';
                visibleCount++;
                filteredProducts.push({
                    handle: productHandle,
                    categories: productCategoryArray
                });
                console.log(`Product ${productHandle}: MATCH - showing (categories: ${productCategoryArray.join(', ')})`);
            } else {
                $product.style.display = 'none';
                console.log(`Product ${productHandle}: NO MATCH - hiding (categories: ${productCategoryArray.join(', ')})`);
            }
        });

        console.log(`Visible products after filtering: ${visibleCount}`);
        console.log('Filtered products:', filteredProducts);

        // ALWAYS hide pagination when custom filters are active
        if($pagination) {
            $pagination.style.display = 'none';
            console.log('Pagination hidden (custom filters active)');
        }
    };

    const filterProducts = (url) => { 
        $main.classList.add("collection-main--loading")
        fetch(url ? url : window.location.href).then(function (response) {
            return response.text();
        }).then(function (html) {
            // Convert the HTML string into a document object
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, 'text/html');
            let prodsHTML = doc.querySelector(".collection-main__grid-products").innerHTML;
            $productGrid.innerHTML = prodsHTML;
            $main.classList.remove("collection-main--loading")
            history.pushState({}, null, url)
            document.getElementById("products").scrollIntoView();
            
            // Re-apply custom filter after AJAX load
            const $customFilterRadiosAfterLoad = document.querySelectorAll(".custom-filter-category-radio");
            if($customFilterRadiosAfterLoad.length > 0) {
                // Re-add event listeners for newly loaded checkboxes
                addCustomFilterListeners();
                // Always reapply filter after AJAX load (even if no checkboxes are checked, to show all products)
                filterProductsByCategory(true);
            }
            
            // PAGINATION AJAX
            // Check if custom filters are active or view=all is in URL
            const $customFilterCheckboxesAfterLoad = document.querySelectorAll(".custom-filter-category-radio");
            const hasActiveCustomFilters = Array.from($customFilterCheckboxesAfterLoad).some($r => $r.checked);
            const urlAfterLoad = new URL(url || window.location.href);
            const hasViewAll = urlAfterLoad.searchParams.has('view') && urlAfterLoad.searchParams.get('view') === 'all';
            
            // Only load and show pagination if no custom filters are active and view=all is not in URL
            if(!hasActiveCustomFilters && !hasViewAll) {
                if(doc.querySelector(".pagination")) {
            $pagination.innerHTML = doc.querySelector(".pagination").innerHTML;
                }
            if(document.querySelector(".pagination span") !== null){
                document.querySelectorAll(".pagination span a").forEach($a => {
                    $a.addEventListener("click", (e) => {
                        e.preventDefault();
                        const { href } = $a;
                        filterProducts(href); 
                    })
                })
            }            
                if($pagination) {
                    $pagination.style.display = '';
                }
            } else {
                // Hide pagination completely when custom filters are active or view=all
                if($pagination) {
                    $pagination.style.display = 'none';
                    $pagination.innerHTML = '';
                }
            }            
        })
    }

    // Add event listeners initially
    addCustomFilterListeners();

    // Check if view=all is in URL on initial load - hide pagination if so
    const initialUrl = new URL(window.location.href);
    const hasViewAllOnLoad = initialUrl.searchParams.has('view') && initialUrl.searchParams.get('view') === 'all';
    if(hasViewAllOnLoad && $pagination) {
        console.log('Initial load: view=all detected - hiding pagination');
        $pagination.style.display = 'none';
    }

    // Initial filter on page load if any checkboxes are checked
    if($customFilterRadios.length > 0) {
        const hasChecked = Array.from($customFilterRadios).some($r => $r.checked);
        if(hasChecked) {
            // Check if we already have view=all in URL
            const currentUrl = new URL(window.location.href);
            if(!currentUrl.searchParams.has('view') || currentUrl.searchParams.get('view') !== 'all') {
                // Load all products if not already loaded
                loadAllProductsForFilter();
            } else {
                // Already have all products, just apply filter
                filterProductsByCategory(true);
            }
        }
    }

    // RADIOS AJAX (for other filters)
    $radios.forEach(($radio) => {
        // Skip custom filter radios as they are handled above
        if($radio.classList.contains('custom-filter-category-radio')) {
            return;
        }

        $radio.addEventListener('change', () => {

            $radios.forEach(($r) => {
                if($r.value !== $radio.value && !$r.classList.contains('custom-filter-category-radio')){
                    $r.checked = false;
                }
            })

            searchParams.delete($radio.name);
            if (searchParams.has("page")) {
                if(Number(searchParams.get("page")) === 1){
                    searchParams.delete('page');
                } else {
                    searchParams.set('page', 1);
                }
            }

            if(document.querySelector(`.collection-main__grid--filters .form__radio[name="${$radio.name}"]`) !== null){
                document.querySelectorAll(`.collection-main__grid--filters .form__radio[name="${$radio.name}"]`).forEach($r => {
                    if($r.checked){
                        searchParams.append($radio.name, $r.value);
                    }
                })
            }

            url.search = searchParams.toString();
            let newUrl = url.toString();
            filterProducts(newUrl)

        });
    });

    // SORT BY AJAX
    if($sortByMobile !== null){
        $sortByMobile.querySelectorAll("input").forEach($input => {
    
            $input.addEventListener('change', () => {
    
                searchParams.delete($input.name);
                if (searchParams.has("page")) {
                    if(Number(searchParams.get("page")) === 1){
                        searchParams.delete('page');
                    } else {
                        searchParams.set('page', 1);
                    }
                }            
    
                $sortByMobile.querySelectorAll("input").forEach(($i) => {
                    if($i !== $input){
                        $i.checked = false;
                    } 
                })
    
                if($input.checked){
                    searchParams.append($input.name, $input.value);
                }
    
                url.search = searchParams.toString();
                let newUrl = url.toString();
                filterProducts(newUrl)            
    
            })
    
        })
    }
    // $sortByMobile.addEventListener('change', () => {
    //     if($sortByMobile.value === ""){
    //         searchParams.delete('sort_by');
    //     } else {
    //         searchParams.set('sort_by', $sortByMobile.value);
    //     }
    //       url.search = searchParams.toString();
    //       let newUrl = url.toString();
    //       filterProducts(newUrl)
    // });    

    // PAGINATION AJAX
    if(document.querySelector(".pagination span") !== null){
        document.querySelectorAll(".pagination span a").forEach($a => {
            $a.addEventListener("click", (e) => {
                e.preventDefault();
                const { href } = $a;
                filterProducts(href);
            })
        })
    }    

    const handleDesktopStickyNav = () => {

        const $grid = document.querySelector(".collection-main__grid");
        const $filters = document.querySelectorAll(".collection-main__grid--filters");

        $filters.forEach($filter => {

            const filtersWidth = $filter.parentElement.clientWidth;
            let trigger;
            let lowerTrigger;
            if (window.matchMedia(`(min-width: 992px)`).matches) {
                trigger = $grid.offsetTop - 36;
                lowerTrigger = trigger + $grid.clientHeight - 212;
                if(scrollY >= lowerTrigger){
                    $filter.style.width = "100%";
                    $filter.style.top = $grid.clientHeight - 212 + "px";
                    $filter.classList.remove("stuck")
                } else if((scrollY >= trigger) && (scrollY <= (lowerTrigger + $filter.clientHeight))){
                    $filter.style.width = filtersWidth + "px";
                    $filter.classList.add("stuck")
                } else {
                    $filter.style.width = "100%";
                    $filter.style.top = 0;
                    $filter.classList.remove("stuck")
                }
            }
    

        })

    }

    handleDesktopStickyNav();

    window.addEventListener("scroll", handleDesktopStickyNav, { passive: true })

}